import i18n from "../i18n";
import {
  Card,
  Text,
  Image,
  FileButton,
  Button,
  Center,
  Avatar,
  Menu,
  ActionIcon,
  Group,
} from "@mantine/core";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { useServerApi } from "../hooks/userServerApi";
import { showNotification } from "@mantine/notifications";
import ReactJson from "react-json-view";
import { IconDotsVertical, IconTrash, IconExternalLink } from "@tabler/icons";

const NameCard = ({ name, form }) => {
  const { t } = useTranslation();
  const { nameCard, _id: entityId } = form.values;
  const [uploading, setUploading] = useState(false);
  const [api] = useServerApi();

  const handleUpload = async (file) => {
    try {
      //   console.log(file);
      setUploading(true);
      let result = await api.uploadFile("files", file, entityId, []);
      setUploading(false);
      if (result && result.success) {
        if (result.data) {
          await form.updateAndSave({ nameCard: result.data });

          showNotification({
            title: `Upload successfully`,
            message: "Upload Success",
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {/* {
        <ReactJson
          src={form.values.nameCard}
          collapsed
          style={{ background: "white" }}
        />
      } */}
      {/* {nameCard?.link && (
        <Image
          src={`${process.env.REACT_APP_FILE_URL}${nameCard.link}`}
          height={100}
        />
      )} */}
      {nameCard && (
        <Group position="right" mb={10}>
          <Menu>
            <Menu.Target>
              <ActionIcon variant="light" size="sm">
                <IconDotsVertical size={16} />
              </ActionIcon>
            </Menu.Target>

            <Menu.Dropdown>
              <Menu.Item
                color="red"
                icon={<IconTrash size={14} />}
                onClick={() => {
                  form.setFieldValue("nameCard", null);
                }}
              >{i18n.t("Remove")}</Menu.Item>
              <Menu.Item
                icon={<IconExternalLink size={14} />}
                onClick={() => {
                  if (nameCard?.link) {
                    window.open(
                      `${process.env.REACT_APP_FILE_URL}${nameCard.link}`,
                      "_blank"
                    );
                  }
                }}
              >{i18n.t("Open in new tab")}</Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </Group>
      )}
      {
        <Center>
          <FileButton onChange={handleUpload} accept="image/png,image/jpeg">
            {(props) => (
              <Avatar
                src={
                  nameCard?.link
                    ? `${process.env.REACT_APP_FILE_URL}${nameCard.link}`
                    : null
                }
                style={{
                  maxWidth: "100%",
                  //   maxHeight: "200px",
                  width: "100%",
                  height: nameCard ? "auto" : "200px",
                  cursor: "pointer",
                }}
                {...props}
              >
                <FontAwesomeIcon icon={faUser} />
              </Avatar>
            )}
          </FileButton>
        </Center>
      }

      {/* <FileButton
        mt={10}
        onChange={handleUpload}
        accept="image/png,image/jpeg"
        multiple={false}
      >
        {(props) => (
          <Button fullWidth {...props}>
            Upload Name Card
          </Button>
        )}
      </FileButton> */}
    </>
  );
};

export default NameCard;
